module.exports = __webpack_public_path__ + "fonts/Roboto-400-greek34.e58ff47.woff2";